import { render, staticRenderFns } from "./ManagerDesktopMenu.vue?vue&type=template&id=042253c6&scoped=true&"
import script from "./ManagerDesktopMenu.vue?vue&type=script&lang=js&"
export * from "./ManagerDesktopMenu.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDesktopMenu.vue?vue&type=style&index=0&id=042253c6&lang=stylus&scoped=true&"
import style1 from "./ManagerDesktopMenu.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042253c6",
  null
  
)

export default component.exports